<template>
  <section id="MainMenu">
    <!-- START MENU HEADER -->
    <header
      class=""
    >
      <nav>
        <div>
          <div class="logo">
            <div>
              <a href="https://www.unam.mx/">
                <img src="@/assets/img/logoUNAM.png" alt="Logo UNAM">
              </a>
              <a href="http://enp.unam.mx/">
                <img src="@/assets/img/logoENP.png" alt="Logo ENP">
              </a>
              <a href="/">
                <img src="@/assets/img/logoUIAPSmall.png" alt="Logo UIAP">
              </a>
            </div>
            <a
              class="navbar-burger is-light-color"
              @click="setActiveMenu"
            >
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
          </div>
          <div class="titulo">
            <h1>
              UNIDAD DE INVESTIGACIÓN<br>
              Y APOYO PEDAGÓGICO
            </h1>
          </div>
        </div>
        <div
          class="menu"
          v-bind:class="{ 'is-active': activeMenu }"
        >
          <router-link
            v-on:click="activeMenu = false"
            v-scroll-to="'#inicio'"
            :to="{ name: 'Home', hash: '#inicio' }"
          >
            <div>Inicio</div>
          </router-link>
          <router-link
            v-on:click="activeMenu = false"
            v-scroll-to="'#nosotros'"
            :to="{ name: 'Home', hash: '#nosotros' }"
          >
            <div>Nosotros</div>
          </router-link>
          <router-link
            v-on:click="activeMenu = false"
            v-scroll-to="'#servicios'"
            :to="{ name: 'Home', hash: '#servicios' }"
          >
            <div>Servicios</div>
          </router-link>
          <router-link
            v-on:click="activeMenu = false"
            v-scroll-to="'#contacto'"
            :to="{ name: 'Home', hash: '#contacto' }"
          >
            <div>Contacto</div>
          </router-link>
          <router-link
            to="/directorio"
            v-on:click="activeMenu = false"
          >
            <div @click="setActiveMenu">Directorio</div>
          </router-link>
        </div>
      </nav>
    </header>
    <!-- END MENU HEADER -->
  </section>
</template>

<script>
export default {
  name: 'MainMenu',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    activeMenu: false,
  }),
  watch: {
    active() {
      this.activeMenu = this.active;
    },
  },
  methods: {
    setActiveMenu() {
      this.activeMenu = !this.activeMenu;
      this.$emit('activate');
    },
  },
};
</script>
<style lang="scss">
  @import '@/assets/styles/colors.scss';
  header{
    height: 95px;
    color: #fff;
    padding: 12px 15px;
    max-height: 20vh;
    position: fixed;
    z-index: 999;
    width: 100%;
    top: 0;
    background-color: $uiap-primary;
  }

  header *:not(.navbar-burger span) {
    height: 100% !important;
    color: #fff;
  }

  header nav{
    display: flex;
    flex-wrap: wrap;
  }

  header nav > :first-child{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  header .logo{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  header .logo > :first-child > *  {
    display: inline-block;
    height: 100%;
    padding: 0 7px;
  }

  header .logo > :first-child :nth-child(2){
    border-left: 1px solid  #fff;
    border-right: 1px solid  #fff;
  }

  header .titulo h1{
    display: none;
    flex-flow: column;
    text-align: left;
    padding-left: 15px;
    justify-content: center;
    font-size: 0.8em;
  }

  header .menu{
    display: none;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
  }

  @media (min-width: 903px){
    header .titulo h1{
      display: flex;
      font-size: 0.7em;
    }
  }
  @media (min-width: 960px){
    header .titulo h1{
      font-size: 1em;
    }
  }

  @media (max-width: 768px){
    header div.menu.is-active{
      width: 100vw;
      display: flex;
      flex-direction: column;
      padding-top: 12px;
    }
    header div.menu.is-active a{
      text-align: left;
      padding: 0 30px;
      background-color: $unam-blue;
      margin: auto -15px;
    }
    header div.menu.is-active a > *{
      padding: 5px;
      border-bottom: 1px solid $green-light;
    }
    header div.menu.is-active a:last-child > *{
      border-bottom: none;
    }
    header div.menu.is-active a > *:hover{
      color: $link-hover;
    }

  }

  @media (min-width: 768px){
    header .menu{
      display: flex;
      flex-flow: row;
      flex-wrap: wrap;
      justify-content: flex-end;
      align-items: center;
      flex-grow: 1;
    }

    header a *:hover{
      color: $link-hover;
    }

    header .menu > *{
      display: flex;
      align-items: center;
      padding: 15px;
      max-width: 30%;
    }
    header .navbar-burger{
      display: none;
    }
    header nav > :first-child, header .logo{
      width: auto;
    }
  }

  @media (max-width: 850px) and (min-width: 768px){
    header{
      padding-left: 2px;
      padding-right: 2px;
    }
    header .menu{
      max-width: none;
    }
    header .titulo h1{
      padding-left: 0;
      /* font-size: 0.8em; */
    }
  }

</style>
